export const BASE_STREAM_URL = '/gateway/api/assist/api/ai';
